var React = require('react');

function ArrowGreyLeft (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M.804 38.647a.805.805 0 0 1-.556-1.386l18.687-17.938L.248 1.386A.805.805 0 0 1 1.361.224l19.291 18.519a.805.805 0 0 1 0 1.161L1.361 38.424a.804.804 0 0 1-.557.223z"}));
}

ArrowGreyLeft.displayName = "ArrowGreyLeft";

ArrowGreyLeft.defaultProps = {"viewBox":"0 0 21 39"};

module.exports = ArrowGreyLeft;

ArrowGreyLeft.default = ArrowGreyLeft;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-grey-left.svg
// module id = 1246
// module chunks = 0